import { gql } from '@apollo/client';

export default gql`
  query accountPendingProductionOrders($accountId: ID!) {
    accountPendingProductionOrders(accountId: $accountId) {
      id
      hexCode
      state
      sendToClinic
      address
      productionOrderItems {
        id
        name
      }
    }
  }
`;
